import {
  Component,
  computed,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'fc-circular-progress',
  template: `
    <div class="flex h-full w-full items-center justify-center">
      <svg
        class="h-full w-full text-{{ circleColor() }} fc-circular-progress__svg"
        viewBox="0 0 100 100"
        [class.fc-circular-progress__svg--spinning]="isSpinning()"
      >
        <circle
          class="fill-current"
          cx="50"
          cy="50"
          r="48"
          fill-opacity="0.08"
        ></circle>
        <circle
          class="stroke-current opacity-20 [stroke-linecap:round] [stroke-width:6px]"
          cx="50"
          cy="50"
          r="45"
          fill="none"
        ></circle>
        <circle
          class="stroke-current transition-all duration-200 ease-linear [stroke-linecap:round] [stroke-width:6px]"
          cx="50"
          cy="50"
          r="45"
          fill="none"
          [attr.stroke-dasharray]="circumference"
          [attr.stroke-dashoffset]="dashOffset()"
        ></circle>
      </svg>
    </div>
  `,
  host: {
    class: 'inline-flex h-full w-full',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: inline-flex;
        height: 100%;
        width: 100%;
      }

      .fc-circular-progress__svg {
        height: 100%;
        width: 100%;
        transform: rotate(-90deg);
        transform-origin: 50% 50%;
      }

      .fc-circular-progress__svg--spinning {
        animation: fc-circular-progress-spin 1s linear infinite;
      }

      @keyframes fc-circular-progress-spin {
        0% {
          transform: rotate(-90deg);
        }

        100% {
          transform: rotate(270deg);
        }
      }
    `,
  ],
})
export class CircularProgressComponent {
  circleColor = input<string>('primary-500');
  progress = input.required<number>();
  active = input<boolean>(true);
  protected readonly normalizedProgress = computed(() => {
    const value = this.progress() ?? 0;

    if (value < 0) {
      return 0;
    }

    if (value > 100) {
      return 100;
    }

    return value;
  });
  protected readonly dashOffset = computed(() => {
    const progressRatio = this.normalizedProgress() / 100;

    return this.circumference * (1 - progressRatio);
  });
  protected readonly isSpinning = computed(
    () => this.active() && this.normalizedProgress() < 100,
  );
  private readonly radius = 45;
  protected readonly circumference = 2 * Math.PI * this.radius;
}
